// Split out of InstanceDetailPage.tsx, then migrated onto components/ui.
//
// The whole tab is the sub-tab switcher plus its two children. The switcher was
// the white-chip-on-grey group, byte-for-byte SegmentedControl's markup, so it
// is the primitive now; `w-fit` is passed through because the primitive's
// container is a plain flex div that would otherwise span the row.

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Instance } from '../../api/client'
import { SegmentedControl } from '../../components/ui'
import { DockerTab } from './DockerTab'
import { ResourcesTab } from './ResourcesTab'
import { UpgradePanel } from './UpgradePanel'

type Section = 'resources' | 'docker' | 'upgrade'

export function AdminTab({ instance }: { instance: Instance }) {
  const { t } = useTranslation()
  const [section, setSection] = useState<Section>('resources')
  return (
    <div className="space-y-4">
      <SegmentedControl<Section>
        label={t('detail.admin.sectionsLabel')}
        value={section}
        onChange={setSection}
        size="sm"
        className="w-fit"
        options={[
          { value: 'resources', label: t('detail.admin.resources') },
          { value: 'docker', label: t('detail.admin.docker') },
          { value: 'upgrade', label: t('detail.admin.upgrade') },
        ]}
      />
      {section === 'resources' && <ResourcesTab instance={instance} />}
      {section === 'docker' && <DockerTab instance={instance} />}
      {section === 'upgrade' && <UpgradePanel instance={instance} />}
    </div>
  )
}
